module.exports = require('./type.shy/style')
